import * as React from 'react';
import styled from 'styled-components';
import * as _ from 'lodash/fp';

import { Checkbox } from '@process-advisor/process-miner/components/shared/checkbox';
import { type StepTooltipProps } from '@process-advisor/process-miner/api/methods/settings/changeStepTooltip';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
`;

export const StepTooltip = () => {
    const [stepTooltip, setStepTooltip] = React.useState<StepTooltipProps>({});
    const onChange = _.curry((
        key: keyof StepTooltipProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const newStepTooltip = { ...stepTooltip, [key]: e.target.checked };
        setStepTooltip(newStepTooltip);
        apiProvider.changeStepTooltip(newStepTooltip);
        apiProvider.rebuildPVDiagram({});
    });

    React.useEffect(() => {
        setStepTooltip(apiProvider.getStepTooltip());
    }, []);

    React.useEffect(() => {
        const listener = () =>
            setStepTooltip(apiProvider.getStepTooltip());
        listener();

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    const label = '# ' + apiProvider.getEntityLower() + 's'
    return (
        <Wrapper>
            <Checkbox
                label={label}
                checked={!!stepTooltip.tasks}
                handleOnChange={onChange('tasks')} />
            <Checkbox
                label='% total'
                checked={!!stepTooltip.total}
                handleOnChange={onChange('total')} />
            <Checkbox
                label='average duration'
                checked={!!stepTooltip.avg_duration}
                handleOnChange={onChange('avg_duration')} />
            <Checkbox
                label='min duration'
                checked={!!stepTooltip.min_duration}
                handleOnChange={onChange('min_duration')} />
            <Checkbox
                label='max duration'
                checked={!!stepTooltip.max_duration}
                handleOnChange={onChange('max_duration')} />
            <Checkbox
                label='std deviation'
                checked={!!stepTooltip.deviation}
                handleOnChange={onChange('deviation')} />
            <Checkbox
                label='comments - internal'
                checked={!!stepTooltip.comments_internal}
                handleOnChange={onChange('comments_internal')} />
            <Checkbox
                label='avg comments - internal'
                checked={!!stepTooltip.avg_comments_internal}
                handleOnChange={onChange('avg_comments_internal')} />
            <Checkbox
                label='perc comments - internal'
                checked={!!stepTooltip.perc_comments_internal}
                handleOnChange={onChange('perc_comments_internal')} />
            <Checkbox
                label='comments - customer'
                checked={!!stepTooltip.comments_customer}
                handleOnChange={onChange('comments_customer')} />
            <Checkbox
                label='avg comments - customer'
                checked={!!stepTooltip.avg_comments_customer}
                handleOnChange={onChange('avg_comments_customer')} />
            <Checkbox
                label='perc comments - customer'
                checked={!!stepTooltip.perc_comments_customer}
                handleOnChange={onChange('perc_comments_customer')} />                
            <Checkbox
                label='worklogs'
                checked={!!stepTooltip.worklogs}
                handleOnChange={onChange('worklogs')} />
            <Checkbox
                label='avg worklogs'
                checked={!!stepTooltip.avg_worklogs}
                handleOnChange={onChange('avg_worklogs')} />
            <Checkbox
                label='perc worklogs'
                checked={!!stepTooltip.perc_worklogs}
                handleOnChange={onChange('perc_worklogs')} />     
            <Checkbox
                label='total timespent'
                checked={!!stepTooltip.total_timespent}
                handleOnChange={onChange('total_timespent')} />                       
            <Checkbox
                label='avg timespent'
                checked={!!stepTooltip.avg_timespent}
                handleOnChange={onChange('avg_timespent')} />   
                               
        </Wrapper>
    );
};
